export default __webpack_public_path__ + "static/media/Learning-cuate.fcd8c151.png";